import {
  GraphContext,
  RelationshipDiagramsSpecificInterface,
  ScopeDataParams,
} from '@ardoq/graph';
import { groupingRuleInterface } from 'modelInterface/groupingRules/groupingRuleInterface';

/**
 * This is a temporary solution to make the transition from BB models to scope data easier.
 *
 * The next step is to create an object with functions that have the same signature as the model interface functions,
 * but are bound to the current scope data. This way we can use the scopeData or BB models interchangeably with minimal
 * refactoring. As soon BB models are no more, we shall pass the scope data instead of the interface object and use the
 * utility functions directly.
 *
 */
export const getRelationshipDiagramsSpecificInterface = (
  scopeDataParams?: ScopeDataParams
) =>
  scopeDataParams
    ? getRelationshipDiagramsInterfaceForEnhancedScopeData(scopeDataParams)
    : getRelationshipDiagramsInterfaceWithModelInterfaces();

const getRelationshipDiagramsInterfaceWithModelInterfaces = () => ({
  getAllGroupingRules: groupingRuleInterface.getAll,
});

const getRelationshipDiagramsInterfaceForEnhancedScopeData = ({
  groupingRules,
}: Pick<
  GraphContext,
  'enhancedScopeData' | 'groupingRules'
>): RelationshipDiagramsSpecificInterface => ({
  getAllGroupingRules: () => groupingRules, // this is stupid, but it's about the shared pattern?
});
